import { screens as o } from "../breakpoints.js";
import { radius as r } from "../radius.js";
import { shadowsLight as m, shadowsDark as a } from "../shadows.js";
import { spaces as s } from "../spaces.js";
import { typography as e } from "../typography.js";
import { darkTheme as t } from "./dark.js";
import { lightTheme as i } from "./light.js";
const l = ["theme", "default", "primary", "secondary", "success", "danger", "warning", "info", "ratings", "slate", "emerald"], w = {
  shadows: m,
  typography: e,
  radius: r,
  screens: o,
  spaces: s,
  ...i
}, y = {
  shadows: a,
  typography: e,
  radius: r,
  screens: o,
  spaces: s,
  ...t
};
export {
  l as colorVariants,
  y as consoleDarkTheme,
  w as consoleLightTheme
};
